'use strict';

var List = require('stb-component-list'),

    Option = require('../modules/models/option'),

    nodeMap = require('../modules/node.map.js');


function SettingsList ( config ) {
    var $panelHint = document.createElement('div'),
        $hint = document.createElement('div');

    this.renderCount = 0;

    config.$node = document.createElement('div');
    config.$node.className = 'body';

    config.$body = document.createElement('div');
    config.$body.className = 'body';

    config.$node.appendChild(config.$body);

    config.cycle = true;

    this.itemIndex = null;

    this.empty = true;

    $panelHint.className = 'panelHint';
    $hint.className = 'hint';
    $hint.innerText = gettext('Settings not found');
    $panelHint.appendChild($hint);

    this.$emptyLabel = document.createElement('div');
    this.$emptyLabel.appendChild($panelHint);
    this.$emptyLabel.className = 'noData hidden';

    this.navigationDisabled = true;

    this.unsavedOptions = {};
    this.unsavedOptionsCounter = 0;

    this.onRenderEnd = null;

    List.call(this, config);
    this.$node.appendChild(this.$emptyLabel);
}


// inheritance
SettingsList.prototype = Object.create(List.prototype);
SettingsList.prototype.constructor = SettingsList;

SettingsList.prototype.name = 'mag-component-layout-list';


SettingsList.prototype.move = function ( code ) {
    if ( this.navigationDisabled ) {
        return;
    }

    List.prototype.move.call(this, code);
};

SettingsList.prototype.renderItem = function ( $node, data ) {
    var self = this;

    /* eslint no-useless-call: 0 */

    $node.listInstance = this;
    $node.onclick = null;
    // $node.onenter = null;
    $node.render = data.render;
    nodeMap.data[data.id] = $node;

    data.refresh = data.get = data.enable = data.disable = data.set = function () {
        if ( DEVELOP ) {
            console.log('NOT IMPLEMENTED');
        }
    };

    if ( data instanceof Option ) {
        if ( data.getter ) {
            console.log('data.getter ' + data.getter.toString());
            console.log(data.cached);
            if ( data.cached === null ) {
                console.log('not cached ' + data.id);
                data.getter.call(data, function ( error, value ) {
                    if ( error ) {
                        console.log('getter error ' + data.id);
                        self.onRenderItem();
                    } else if ( typeof data.prepareForRender === 'function' ) {
                        data.prepareForRender.call(data, value, function ( preparedData ) {
                            data.cached = preparedData;
                            data.render.call(data, preparedData, function () {
                                self.onRenderItem();
                            });
                        });
                    } else {
                        data.cached = value;
                        console.log('render cached value ' + data.cached + ' now ' + data.id);
                        data.render.call(data, value, function () {
                            self.onRenderItem();
                        });
                    }
                });
            } else {
                console.log('render cached ' + data.id);
                data.render.call(data, data.cached, function () {
                    self.onRenderItem();
                });
            }
        } else {
            console.log('simple render ' + data.id);
            data.render.call(data, null, function () {
                self.onRenderItem();
            });
        }
    } else {
        // section
        console.log('the simplest render ' + data.id);
        data.render({}, function () {
            self.onRenderItem();
        });
    }
};


SettingsList.prototype.$nodeChange = function ( isChanged, option, value ) {
    // console.log('node changed? ' + isChanged + ' ' + option.id);
    if ( isChanged ) {
        this.unsavedOptions[option.id] = {
            option: option,
            value: value
        };
        // console.log(option);
        ++this.unsavedOptionsCounter;
    } else if ( this.unsavedOptionsCounter > 0 ) {
        this.unsavedOptions[option.id] = null;
        --this.unsavedOptionsCounter;
    }
    // console.log('this.unsavedOptions ' + this.unsavedOptionsCounter)
    // console.log('this.unsavedOptions ' + this.unsavedOptionsCounter !== 0)

    this.emit('change', this.unsavedOptionsCounter !== 0);
};

/* eslint no-loop-func: 0 */
SettingsList.prototype.save = function ( callback ) {
    var self = this,
        savedSections = {};

    if ( this.unsavedOptionsCounter !== 0 ) {
        Object.keys(this.unsavedOptions).forEach(function ( optionId ) {
            var data;

            if ( self.unsavedOptions[optionId] === null ) {
                // skip already saved options
                return;
            }

            data = self.unsavedOptions[optionId];
            // console.log(typeof data.option.prepareForSave === 'function')
            if ( typeof data.option.prepareForSave === 'function' ) {
                // console.log('onsave ' + data.option.section.onsave)
                if ( data.option.section.onsave ) {
                    savedSections[data.option.section.id] = data.option.section;
                }
                data.option.prepareForSave.call(data.option, data.value, function ( error, afterSave ) {
                    // console.log(!error && typeof data.option.saver === 'function')
                    if ( !error && typeof data.option.saver === 'function' ) {
                        data.option.saver.call(data.option, function ( error, saverCallback ) {
                            if ( !error ) {
                                self.unsavedOptions[optionId].option.emit('saved', self.unsavedOptions[optionId].value);
                                self.unsavedOptions[optionId] = null;
                                --self.unsavedOptionsCounter;

                                if ( self.unsavedOptionsCounter === 0 ) {
                                    self.emit('change', false);
                                    Object.keys(savedSections).forEach(function ( id ) {
                                        savedSections[id].onsave();
                                    });
                                    callback();
                                }

                                if ( typeof afterSave === 'function' ) {
                                    afterSave.call(data.option);
                                }
                            }

                            if ( typeof saverCallback === 'function') {
                                saverCallback.call(data.option, error);
                            }
                        });
                    } else {
                        self.unsavedOptions[optionId].option.emit('saved', self.unsavedOptions[optionId].value);
                        self.unsavedOptions[optionId] = null;
                        --self.unsavedOptionsCounter;

                        if ( self.unsavedOptionsCounter === 0 ) {
                            self.emit('change', false);
                            Object.keys(savedSections).forEach(function ( id ) {
                                savedSections[id].onsave();
                            });
                            callback();
                        }
                    }
                });
            } else {
                // console.log('onsave ' + data.option.section.onsave)
                if ( data.option.section.onsave ) {
                    savedSections[data.option.section.id] = data.option.section;
                }
                data.option.saver.call(data.option, function ( error, saverCallback ) {
                    // console.log('saved? ' + !error);
                    if ( !error ) {
                        self.unsavedOptions[optionId] = null;
                        --self.unsavedOptionsCounter;

                        // console.log('saved');
                        if ( self.unsavedOptionsCounter === 0 ) {
                            self.emit('change', false);
                            Object.keys(savedSections).forEach(function ( id ) {
                                savedSections[id].onsave();
                            });
                            callback();
                        }
                    }

                    if ( typeof saverCallback === 'function' ) {
                        saverCallback.call(data.option, error);
                    }
                });
            }
        });
    }
};


SettingsList.prototype.getSaveRequirements = function (  ) {
    var self = this,
        requirements = {
            reload: false
        },
        data;

    if ( this.unsavedOptionsCounter !== 0 ) {
        Object.keys(this.unsavedOptions).forEach(function ( optionId ) {
            if ( self.unsavedOptions[optionId] !== null ) {
                data = self.unsavedOptions[optionId];

                if ( data.option.requirePortalReboot ) {
                    requirements.reload = requirements.reload || {};
                    requirements.reload.portal = true;
                }

                if ( data.option.requireDeviceReboot ) {
                    requirements.reload = requirements.reload || {};
                    requirements.reload.device = true;
                }
            }
        });
    }

    return requirements;
};


SettingsList.prototype.onRenderItem = function () {
    --this.renderCount;

    // console.log(this.renderCount);
    if ( this.renderCount === 0 ) {
        if ( this.onRenderEnd !== null ) {
            this.onRenderEnd();
            this.onRenderEnd = null;
        }

        if ( this.itemIndex !== null && !isNaN(this.itemIndex) ) {
            this.focusIndex(this.itemIndex);
        }
    }
};


SettingsList.prototype.renderView = function ( index ) {
    var focusIndex;

    if ( this.$focusItem ) {
        focusIndex = this.$focusItem.index;
    }

    console.log('viewIndex ' + this.viewIndex);
    console.log(index);

    this.blurItem(this.$focusItem);

    if ( this.viewIndex === -1 || this.viewIndex === null ) {
        nodeMap.data = {};
        this.itemIndex = null;
        this.data.forEach(function ( item ) {
            item.cached = null;
        });
    } else {
        this.itemIndex = this.viewIndex < index ? focusIndex + 1 : focusIndex - 1;
        console.log(JSON.stringify([this.data.length, index, this.size]));
        if ( index === 0 ) {
            this.itemIndex = 0;
        } else if ( this.data.length === index + this.size && this.viewIndex <= this.size ) {
            this.itemIndex = this.data.length - 1;
        } else if ( this.viewIndex < index ) {
            // going down
            console.log('going down');
        } else {
            // going up
            console.log('going up');
        }
    }


    this.renderCount = this.data.length < this.size ? this.data.length : this.size;
    console.log(' this.renderCount ' + this.renderCount);

    if  ( this.renderCount === 0 ) {
        this.renderCount = this.size;
        this.data = new Array(this.size);
        this.$body.classList.add('hidden');
        this.$emptyLabel.classList.remove('hidden');
        this.navigationDisabled = true;
        this.empty = true;
        List.prototype.renderView.call(this, index);
    } else {
        if ( this.empty ) {
            this.$body.classList.remove('hidden');
            this.$emptyLabel.classList.add('hidden');
            this.navigationDisabled = false;
            this.empty = false;
        }
        List.prototype.renderView.call(this, index);
    }
};


SettingsList.prototype.render = function ( data, callback ) {
    this.viewIndex = -1;
    this.data = data;

    if ( callback ) {
        this.onRenderEnd = callback;
    }

    this.renderView(0);
};


SettingsList.prototype.refresh = function () {
    var self = this,
        focusIndex = self.viewIndex;

    if ( self.$focusItem ) {
        focusIndex = self.$focusItem.index;
    }

    self.render(self.data, function () {
        self.focusIndex(focusIndex);
    });
};


SettingsList.prototype.initialize = function ( backItem, config ) {
    var self = this,
        focusIndex = self.viewIndex;


    if ( config.focusIndex ) {
        focusIndex = config.focusIndex;
    } else {
        focusIndex = self.$focusItem.index;
    }

    if ( config.data ) {
        self.data = config.data;
    }

    if ( backItem !== null ) {
        self.data.unshift(backItem);
    }

    self.render(self.data, function () {
        if ( config.viewIndex ) {
            self.renderView(config.viewIndex);
        } else if ( self.data[focusIndex] ) {
            self.focusIndex(focusIndex);
        } else {
            self.focusIndex(0);
        }
    });
};


// correct component name
module.exports = SettingsList;
